const Header = () => {
	return ( 
		<div className="row text-center header">
			<h1>TODOS</h1>
		</div>
	 );
}
 
export default Header;